import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon, MinusIcon, ShieldCheckIcon, XIcon } from 'lucide-react';
import { clutterTypes, heroBadges, heroNegations, heroStats, mockupUrl, pricingAnchor } from '../data/content';
import { Button } from './ui/Button';
import { Highlight } from './ui/Section';
export function Hero() {
  return <section className="px-4 pb-14 pt-9 md:pb-20 md:pt-12" data-id="element-110" data-mp="4njqkdok21ck">
      <div className="mx-auto max-w-5xl text-center" data-id="element-111" data-mp="129qudld1bpnv">
        <p className="text-xs font-extrabold uppercase tracking-[.2em] text-yellow-700 md:text-sm" data-id="element-112" data-mp="127ec173d7daa">
          Bright Digital Hub
        </p>
        <h1 className="mx-auto mt-3 max-w-4xl text-[2.4rem] font-black uppercase leading-[1] tracking-tight text-blue-950 md:text-[4.5rem]" data-id="element-113" data-mp="sai4p4p7cx7b">
          🏠 Clear the Clutter™
        </h1>

        <a href={pricingAnchor} className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Go to the CLEAR THE CLUTTER™ offer" data-id="element-114" data-mp="3d1a4za4glt8j">
          <img className="w-full max-w-[640px] object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="CLEAR THE CLUTTER™ box set with 5 volumes and 5 bonuses" data-id="element-115" data-mp="3j7zgfm2d3yi9" />
        </a>

        <p className="mx-auto max-w-4xl text-2xl font-black uppercase leading-tight text-blue-950 md:text-4xl" data-id="element-116" data-mp="3e9607lvoxtee">
          <Highlight data-id="element-117" data-mp="30hhnphhj52ww">5 Complete Volumes + 5 Practical Bonuses</Highlight>
        </p>

        <h2 className="mx-auto mt-10 max-w-3xl text-xl font-black leading-snug text-blue-950 md:text-3xl" data-id="element-118" data-mp="358hleoyh3p0g">
          Too many things at home — and every item gives you another reason to keep it?
        </h2>

        <ul className="mx-auto mt-6 grid max-w-3xl gap-2.5 text-left sm:grid-cols-2" data-id="element-119" data-mp="2viev4wiqkp5t">
          {clutterTypes.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold text-slate-700 md:text-base" data-id="element-120" data-mp="2hkgibvk2d0sf">
              <XIcon className="h-5 w-5 shrink-0 text-red-600" aria-hidden="true" data-id="element-121" data-mp="s3mcg0c5huxb" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-base font-bold leading-relaxed text-slate-700 md:text-lg" data-id="element-122" data-mp="ic889f9986xu">
          <b className="text-blue-950" data-id="element-123" data-mp="ddf0m3gnfa5l">CLEAR THE CLUTTER™</b> gives you a practical system to decide{' '}
          <span className="underline decoration-amber-400 decoration-4 underline-offset-4" data-id="element-124" data-mp="1b1fel0eya0tn">
            what stays, what goes, and what happens next.
          </span>
        </p>

        <ul className="mx-auto mt-6 flex max-w-3xl flex-col items-center justify-center gap-2 text-sm font-black text-blue-950 md:flex-row md:gap-6 md:text-base" data-id="element-125" data-mp="112pur23hu6ar">
          {heroNegations.map(line => <li key={line} className="flex items-center gap-1.5" data-id="element-126" data-mp="3lsp2bagmmdcu">
              <MinusIcon className="h-4 w-4 text-red-600" aria-hidden="true" data-id="element-127" data-mp="3lquf1phvu95l" />
              {line}
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-128" data-mp="1x9um0eak5jp0">
          You work with one small category, a few items, and clear questions that help you make
          the next decision.
        </p>

        <p className="mx-auto mt-7 inline-flex flex-wrap items-center justify-center gap-2 rounded-2xl bg-blue-950 px-5 py-3 text-sm font-black uppercase tracking-wide text-white md:text-lg" data-id="element-129" data-mp="268ognz4bvzzx">
          One Item <ArrowRightIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-130" data-mp="2fzj436tb95my" /> One
          Decision <ArrowRightIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-131" data-mp="2kx2ge16g78c9" /> One
          Destination
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-132" data-mp="2oyo1g9t4ysxj">
          {heroBadges.map(badge => <span key={badge} className="flex items-center gap-1.5" data-id="element-133" data-mp="uo0shxp2cmo0">
              <CheckIcon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-134" data-mp="zkr9cn8ozmah" />
              {badge}
            </span>)}
        </div>

        <div className="mt-8" data-id="element-135" data-mp="4dgyix4pnr96">
          <Button href={pricingAnchor} className="w-full text-base md:w-auto md:px-12 md:text-xl" subtext="Yes! Show me today’s launch price →" data-id="element-136" data-mp="3vhxg7je3l7yj">
            I’m ready to clear my home
          </Button>
          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-137" data-mp="9b0atrhultyh">
            <span className="flex items-center gap-1" data-id="element-138" data-mp="3cr7evz46dt7s">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-139" data-mp="3csifjq2bqkuo" /> 7-day guarantee
            </span>
            <span className="flex items-center gap-1" data-id="element-140" data-mp="3rhmzbborox4w">
              <LockIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-141" data-mp="3motxavkoo2wi" /> Secure payment
            </span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-142" data-mp="2yyhshtkqima5">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-slate-200 bg-white p-4 text-center shadow-sm" data-id="element-143" data-mp="2tylnps47qqtj">
              <p className="text-2xl font-black text-blue-950 md:text-3xl" data-id="element-144" data-mp="1e9ned3iqn30j">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-145" data-mp="zkzn39fxdfge">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}